const DeleteRequest = (props) => {
  var dataToPost = props.data;
  if(dataToPost == undefined) { dataToPost = {} }
  dataToPost.authenticity_token = $('meta[name=csrf-token]').attr('content');

  const requestOptions = {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify(dataToPost),
  };

  updateRequestCount(1);
  return fetch(props.url, requestOptions)
    .then(async response => {
      updateRequestCount(-1);
      const isJson = response.headers.get('content-type')?.includes('application/json');
      const data = isJson && await response.json();

      if (!response.ok) {
        const error = (data && data.message) || response.status;

        if(response.status == 500) {
          trackEvent('js_error_happened', {
            source:  "DeleteRequest returned 500",
            url: props.url,
            dataToPost: dataToPost,
            response: data,
          });
        }

        if(props[response.status] != undefined) {
          props[response.status](data);
        }
        return Promise.reject(error);
      }

      if(response.redirected && props[302] != undefined) {
        props[302](data);
        return data;
      }

      props.callback(data);
      return data;
    })
    .catch((error) => {
      console.error('[DeleteRequest] There was an error!', error);
      throw error;
    });
}

export default DeleteRequest
